"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _FileTypeContainer = _interopRequireDefault(require("./FileTypeContainer"));
var _PlayArrow = _interopRequireDefault(require("@material-ui/icons/PlayArrow"));
var _SaveAlt = _interopRequireDefault(require("@material-ui/icons/SaveAlt"));
var _Loupe = _interopRequireDefault(require("@material-ui/icons/Loupe"));
var _IconButton = require("./IconButton");
var _clsx7 = _interopRequireDefault(require("clsx"));
var _Tooltip = require("./Tooltip");
var _ThumbnailDefault = require("../icons/ThumbnailDefault");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: function root(props) {
      return _objectSpread({
        margin: 1,
        padding: "8px 16px",
        backgroundColor: _pittaModules.LightColors.primary["0"]
      }, props.hoverable && {
        cursor: "pointer",
        "&:hover, &:active": {
          // margin: 0,
          padding: theme.spacing(0.875, 1.875),
          border: "2px solid ".concat(_pittaModules.LightColors.primary["7"])
        }
      });
    },
    rootApp: function rootApp(props) {
      return {
        padding: "10px 12px 7px"
      };
    },
    rootBorder: {
      border: "1px solid ".concat(_pittaModules.LightColors.primary["5"]),
      borderRadius: 10
    },
    rootHover: {
      margin: 0,
      padding: "".concat(theme.spacing(0.875, 1.875), "!important"),
      border: "2px solid ".concat(_pittaModules.LightColors.primary["7"], "!important")
    },
    rootAppHover: {
      margin: 0,
      padding: "".concat(theme.spacing(1.125, 1.25, 0.75), "!important"),
      border: "2px solid ".concat(_pittaModules.LightColors.primary["7"], "!important")
    },
    contentWrapT: {
      display: "flex",
      justifyContent: "space-between",
      paddingBottom: function paddingBottom(props) {
        return props.hoverCard ? theme.spacing(1) : props.app && props.content !== "" ? "5px" : props.app ? "11px" : theme.spacing(0.5);
      }
    },
    appContentWrapT: {
      paddingBottom: 11
    },
    contents: {
      display: "flex",
      justifyContent: "space-between"
    },
    contentWrapM: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flex: 1,
      flexDirection: "column"
    },
    appMiddleContentDiv: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    HcontentWrapT: {
      paddingBottom: theme.spacing(1),
      display: "flex",
      justifyContent: "space-between"
    },
    speed: _objectSpread({}, theme.direction === "rtl" ? {
      textAlign: "left"
    } : {
      textAlign: "right"
    }),
    iconWrap: _objectSpread({
      padding: 0
    }, theme.direction === "rtl" ? {
      textAlign: "left"
    } : {
      textAlign: "right"
    }),
    save: {
      padding: 0
    },
    play: _objectSpread({
      padding: 0
    }, theme.direction === "rtl" ? {
      marginRight: theme.spacing(2)
    } : {
      marginLeft: theme.spacing(2)
    }),
    appPlay: _objectSpread({}, theme.direction === "rtl" ? {
      marginRight: theme.spacing(1.5),
      marginLeft: 3
    } : {
      marginLeft: theme.spacing(1.5),
      marginRight: 3
    }),
    thumbnail: _objectSpread(_objectSpread({
      position: "relative",
      width: 80,
      height: 80,
      backgroundColor: _pittaModules.LightColors.primary["1"]
    }, theme.direction === "rtl" ? {
      marginLeft: theme.spacing(1)
    } : {
      marginRight: theme.spacing(1)
    }), {}, {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }),
    eventWrap: {
      display: "flex",
      width: "100%",
      justifyContent: "space-between"
    },
    eventAppWrap: {
      paddingBottom: 3
    },
    thumbplay: {
      display: "flex",
      position: "absolute",
      zIndex: 3,
      padding: 0,
      color: _pittaModules.LightColors.primary["0"]
    },
    circle: {
      width: 36,
      height: 36,
      borderRadius: 50,
      opacity: 0.45,
      backgroundColor: _pittaModules.LightColors.primary["1"],
      display: "flex",
      position: "absolute",
      zIndex: 2
    },
    content: {
      paddingBottom: 4
    },
    contentAlt: {
      paddingBottom: 4
    },
    event: {
      padding: 0
    },
    appContentAlt: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: 4
    },
    appContentNoContentAlt: {
      marginTop: 6
    }
  });
});
var EventItem = function EventItem(props) {
  var _clsx2, _clsx3, _clsx6;
  var mobile = props.mobile,
    heading = props.heading,
    speed = props.speed,
    fileType = props.fileType,
    eventCode = props.eventCode,
    content = props.content,
    content2 = props.content2,
    contentAlt = props.contentAlt,
    thumbnail = props.thumbnail,
    hoverCard = props.hoverCard,
    hover = props.hover,
    play = props.play,
    zoomBtn = props.zoomBtn,
    download = props.download,
    noBorder = props.noBorder,
    onPlay = props.onPlay,
    onDownload = props.onDownload,
    _onClick = props.onClick,
    onZoom = props.onZoom,
    className = props.className,
    style = props.style,
    isAI = props.isAI,
    t = props.t,
    app = props.app;
  var classes = useStyle(props);
  var theme = (0, _core.useTheme)();
  // const anchorRef = React.useRef<HTMLButtonElement>(null);

  var thumbnailMarkup = (0, _react.useMemo)(function () {
    if (thumbnail) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.thumbnail
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: thumbnail,
        style: {
          width: "100%",
          height: "100%"
        },
        alt: "Thumbnail Image"
      }), onPlay && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.circle
      }), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
        color: "secondary",
        className: classes.thumbplay,
        onClick: function onClick(e) {
          e.stopPropagation();
          onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        }
      }, /*#__PURE__*/_react.default.createElement(_PlayArrow.default, null))));
    }
    if (thumbnail === null && fileType === "Event") {
      if (onPlay) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: classes.thumbnail
        }, /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: 80,
            height: 80,
            backgroundColor: "black"
          }
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: classes.circle
        }), /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
          color: "secondary",
          className: classes.thumbplay,
          onClick: function onClick(e) {
            e.stopPropagation();
            onPlay === null || onPlay === void 0 ? void 0 : onPlay();
          }
        }, /*#__PURE__*/_react.default.createElement(_PlayArrow.default, null)));
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.thumbnail
      }, /*#__PURE__*/_react.default.createElement(_ThumbnailDefault.ThumbnailDefault, {
        style: {
          width: 80,
          height: 80
        }
      }));
    }
    return "";
  }, [classes.circle, classes.thumbnail, classes.thumbplay, fileType, onPlay, thumbnail]);
  var iconMarkup = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.iconWrap
    }, download && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      title: "Download",
      placement: "bottom",
      disableTouchListener: mobile
    }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
      color: "secondary",
      className: classes.save,
      onClick: function onClick(e) {
        e.stopPropagation();
        onDownload === null || onDownload === void 0 ? void 0 : onDownload();
      }
    }, /*#__PURE__*/_react.default.createElement(_SaveAlt.default, null))), play && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      title: "Play",
      placement: "right",
      disableTouchListener: mobile
    }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
      color: "secondary",
      className: (0, _clsx7.default)(classes.play, _defineProperty({}, classes.appPlay, app)),
      onClick: function onClick(e) {
        e.stopPropagation();
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
      }
    }, /*#__PURE__*/_react.default.createElement(_PlayArrow.default, null))), zoomBtn && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      title: "Zoom in",
      placement: "right",
      disableTouchListener: mobile
    }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
      color: "secondary",
      className: classes.play,
      onClick: function onClick(e) {
        e.stopPropagation();
        onZoom === null || onZoom === void 0 ? void 0 : onZoom();
      }
    }, /*#__PURE__*/_react.default.createElement(_Loupe.default, null))));
  }, [app, classes.appPlay, classes.iconWrap, classes.play, classes.save, download, mobile, onDownload, onPlay, onZoom, play, zoomBtn]);
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    dir: theme.direction,
    elevation: 0,
    className: (0, _clsx7.default)(classes.root, (_clsx2 = {}, _defineProperty(_clsx2, classes.rootApp, app), _defineProperty(_clsx2, classes.rootAppHover, app && hover), _defineProperty(_clsx2, classes.rootHover, hover), _defineProperty(_clsx2, classes.rootBorder, !noBorder), _clsx2), className),
    style: style,
    onClick: function onClick(e) {
      e.stopPropagation();
      _onClick === null || _onClick === void 0 ? void 0 : _onClick();
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(classes.contentWrapT, (_clsx3 = {}, _defineProperty(_clsx3, classes.HcontentWrapT, app && hover), _defineProperty(_clsx3, classes.appContentWrapT, app), _clsx3), !hoverCard && classes.HcontentWrapT)
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: app ? "CaptionBold" : hoverCard ? "CaptionBold" : "SmallBold"
  }, heading), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    className: classes.speed,
    category: "Default",
    variant: app ? "CaptionBold" : hoverCard ? "CaptionBold" : "SmallBold",
    dir: "ltr"
  }, speed)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(classes.contents)
  }, thumbnailMarkup, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentWrapM
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(_defineProperty({}, classes.appMiddleContentDiv, app)),
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)(classes.eventWrap, _defineProperty({}, classes.eventAppWrap, app))
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement(_FileTypeContainer.default, {
    className: classes.event,
    fileType: fileType,
    eventCode: eventCode,
    isAI: isAI,
    t: t
  })), !app && iconMarkup), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    className: classes.content,
    category: "Default",
    variant: hoverCard ? "Caption" : "Small"
  }, content)), app && iconMarkup), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx7.default)((_clsx6 = {}, _defineProperty(_clsx6, classes.appContentAlt, app), _defineProperty(_clsx6, classes.appContentNoContentAlt, app && content === ""), _clsx6))
  }, contentAlt ? /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    className: (0, _clsx7.default)(!app && classes.contentAlt),
    category: "Default",
    variant: app ? "Small" : "Caption",
    htmlColor: _pittaModules.LightColors.primary["2"]
  }, contentAlt) : "", /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: hoverCard && !app ? "Caption" : app ? "Small" : "Small",
    htmlColor: _pittaModules.LightColors.primary["3"]
  }, content2)))));
};
var _default = EventItem;
exports.default = _default;